<div [id]="id" tabindex="-1" class="fixed top-0 left-0 right-0 z-50 hidden w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full" [hidden]="hidden">
    <div class="relative w-96 max-h-full rounded-lg primary-purple-light-2-background mx-auto mt-20">
        <div class="relative rounded-lg shadow dark:bg-gray-700">
            @if (loading) {
                <section class="p-6">
                    <div class="flex w-full pt-6 pb-3 justify-center">
                        <img [src]="images.loading" alt="loading" class="h-10 w-10" />
                    </div>
                    <div class="flex items-center justify-center">
                        <h3 class="text-xl font-bold mb-6 text-gray-500 dark:text-gray-400 primary-purple-light-text">{{ literalService.get('towns.actions.newTown.creating', true) }}…</h3>
                    </div>
                </section>
            } @else {
                <form #form novalidate (ngSubmit)="onSubmit()">
                    <div class="items-center px-6 pt-6 mb-5">
                        <div class="flex items-center justify-between">
                            <h3 class="text-lg font-bold primary-purple-text">{{ literalService.get('towns.actions.newTown.title', true) }}</h3>
                            <button type="button" (click)="close()" class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 inline-flex justify-center items-center">
                                <img [src]="images.close" class="h-6 w-6" alt="close" />
                            </button>
                        </div>
                    </div>
                    <div class="px-6 space-y-3">
                        <div>
                            <label class="text-normal text-left block mb-1">{{ literalService.get('towns.fields.name', true) }}</label>
                            <input type="text" [(ngModel)]="name" [ngModelOptions]="{standalone: true}" required class="block w-full px-3 py-2 bg-white border rounded-s rounded-e text-base font-normal focus:outline-none" />
                        </div>
                        <div>
                            <label class="text-normal text-left block mb-1">{{ literalService.get('towns.fields.latitude', true) }}</label>
                            <input type="number" step="any" [(ngModel)]="latitude" [ngModelOptions]="{standalone: true}" required class="block w-full px-3 py-2 bg-white border rounded-s rounded-e text-base font-normal focus:outline-none" />
                        </div>
                        <div>
                            <label class="text-normal text-left block mb-1">{{ literalService.get('towns.fields.longitude', true) }}</label>
                            <input type="number" step="any" [(ngModel)]="longitude" [ngModelOptions]="{standalone: true}" required class="block w-full px-3 py-2 bg-white border rounded-s rounded-e text-base font-normal focus:outline-none" />
                        </div>
                        <div>
                            <label class="text-normal text-left block mb-1">{{ literalService.get('towns.fields.timezone', true) }}</label>
                            <select2 class="block w-full" [data]="timezones" [value]="timezone" [placeholder]="literalService.get('towns.fields.timezonePlaceholder', true)" [templates]="{option: option}" (update)="onTimezoneChange($event)">
                                <ng-template #option let-label="label">
                                    <app-select2-option [label]="label" />
                                </ng-template>
                            </select2>
                        </div>
                        @if (canEditClients) {
                            <div class="relative">
                                <label class="text-normal text-left block mb-1">{{ literalService.get('towns.fields.clients', true) }}</label>
                                <app-multi-select-form [title]="'newTown-clients'" [elements]="clients" [values]="selectedClients" [width]="'full'" [placeholder]="literalService.get('towns.fields.clientsPlaceholder', true)" />
                            </div>
                        }
                    </div>
                    <div class="flex px-6 py-6">
                        <button type="button" class="secondary mt-2 mr-2 gap-4 border-2 font-semibold h-11 w-full uppercase cursor-pointer bg-white" (click)="close()">{{ literalService.get('cancel', true) }}</button>
                        <button type="submit" class="primary mt-2 gap-4 border-2 font-semibold h-11 w-full uppercase cursor-pointer text-white" [disabled]="!isValid">{{ literalService.get('confirm', true) }}</button>
                    </div>
                </form>
            }
        </div>
    </div>
</div>
